import { PrivateLandlord } from '@modules/husleie-framework/src/types/PrivateLandlord.entity';
import { ProfessionalLandlord } from '@modules/husleie-framework/src/types/ProfessionalLandlord.entity';
import { RentalObject } from '@modules/husleie-framework/src/types/RentalObject.entity';
import { SigningStatus } from '@modules/husleie-framework/src/types/Signing.entity';
import { ImageSlide } from '@modules/husleie-framework/src/types/Swiper.entity';
import { Tenant } from '@modules/husleie-framework/src/types/Tenant.entity';
import { UserRole } from '@modules/husleie-framework/src/types/User.entity';

const enum SessionTypeEnum {
  CONTRACT = 'CONTRACT',
  MOVE_IN = 'MOVE_IN',
  MOVE_OUT = 'MOVE_OUT',
  INSPECTION = 'INSPECTION',
  DEPOSIT_ACCOUNT = 'DEPOSIT_ACCOUNT',
}

type SessionType =
  | SessionTypeEnum.CONTRACT
  | SessionTypeEnum.MOVE_IN
  | SessionTypeEnum.MOVE_OUT
  | SessionTypeEnum.INSPECTION
  | SessionTypeEnum.DEPOSIT_ACCOUNT;

interface Session {
  uuid: string;
  signingUuid?: string;
  signerUuid?: string;
  signerRole?: UserRole;
  type: SessionType;
  status: null | SigningStatus;
  tenancyId?: number;
  landlord: PrivateLandlord | ProfessionalLandlord;
  tenant?: Tenant;
  coTenants: Tenant[];
  rentalObject: RentalObject;
  comment?: string;
  images?: ImageSlide[];
  pdfLink?: string;
  preview?: {
    html?: any;
    pdf?: any;
  };
  created?: string;
  modified?: string;
}

export { Session, SessionType, SessionTypeEnum };
